import http from 'apis/config/http-service';
import qs from 'qs';
import { useInfiniteQuery } from 'react-query';
import type { LookupRestaurant } from './types';

const endpoint = 'restaurants';
const PAGE_SIZE = 20;

interface LookupRestaurantsPage {
  data: LookupRestaurant[];
  page: number;
  pageCount: number;
  total: number;
}

// The picker shows ALL restaurants immediately (newest first), infinite-
// scrolled; `search` narrows server-side. No minimum-characters gate.
//
// This hits the legacy elkaso-backend `GET restaurants` endpoint (nestjsx/crud
// CrudController, see restaurant.controller.ts#getMany) — verified its
// GetManyDefaultResponse envelope is exactly `{ data, page, pageCount, total }`,
// matching this hook's field names as written.
export const useInfiniteLookupRestaurantsApi = (search: string) => {
  const trimmed = search.trim();

  return useInfiniteQuery(
    [endpoint, 'lookup-infinite', trimmed],
    async ({ pageParam = 1 }): Promise<LookupRestaurantsPage> => {
      const filters: string[] = [];
      if (trimmed) filters.push(`nameEn||$contL||${trimmed}`);

      const { data } = await http.get(endpoint, {
        params: {
          page: pageParam,
          limit: PAGE_SIZE,
          sort: 'id,DESC',
          filter: filters.length > 0 ? filters : undefined,
        },
        paramsSerializer: (params) => qs.stringify(params, { arrayFormat: 'repeat' }),
      });
      return data;
    },
    {
      getNextPageParam: (last) => (last.page < last.pageCount ? last.page + 1 : undefined),
      keepPreviousData: true,
      staleTime: 1000 * 60,
    }
  );
};
